import { Attributes, ModelBase, Rules, Validation } from '@singularsystems/neo-core';
import { InterestCalculationType } from './InterestCalculationType.enum';

export default class InterestRateCalculationType extends ModelBase {
    static typeName = "InterestRateCalculationType";

    constructor() {
        super();
        this.makeObservable();
    }

    public interestRateCalculationTypeId: number = 0;

    public interestCalculationType: InterestCalculationType = InterestCalculationType.Linear;

    public includeSpreadInMargin: boolean = false;

    @Rules.Required()
    @Rules.StringLength(50)
    public calculationName: string = "";

    @Rules.StringLength(200)
    public description: string = "";

    @Rules.Required()
    @Rules.StringLength(100)
    public formula: string = "";

    @Attributes.Integer()
    public ordinal: number = 99;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.calculationName) {
            return "New interest rate calculation type";
        } else {
            return this.calculationName;
        }
    }
}